import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import { MODULES_KEY, PERMISSION_OBJECT, ROUTES } from '../../common/constants';
import Statistics from './Statistics';
import './statistics.less';

const StatisticsWrapper = () => (
  <Switch>
    <Route
      exact
      path={ROUTES?.STATISTICS}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.STATISTICS}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <Statistics {...props} />
        </AccessControl>
      )}
    />
  </Switch>
);

export default StatisticsWrapper;
